import { HTMLAttributes } from 'react';
import useLocale from '@/client/hooks/use-locale';
import { ApiTranslation } from '../api-translation';

type LocalizedTextProps = HTMLAttributes<HTMLSpanElement> & {
  // Per-locale map from the backend (name_i18n / rule_i18n / title_i18n).
  i18nMap?: Record<string, string> | null;
  // English base text used when the map has no entry for the current locale.
  fallback: string;
};

/**
 * Render a client-reviewed per-locale translation when the current locale is
 * present in i18nMap; otherwise fall back to the English base text and let
 * ApiTranslation machine-translate it (existing behaviour). This keeps the
 * priority order pickI18n -> ApiTranslation -> raw: the human translation wins
 * only when the map actually has the locale, so we never feed an already
 * localized string back into the machine translator.
 */
export function LocalizedText({ i18nMap, fallback, ...attrs }: LocalizedTextProps) {
  const { locale } = useLocale();
  const lang = (locale || '').toLowerCase();
  const hit = i18nMap ? i18nMap[lang] || i18nMap[lang.split('-')[0]] : undefined;
  if (hit) return <span {...attrs}>{hit}</span>;
  return <ApiTranslation {...attrs}>{fallback}</ApiTranslation>;
}

export default LocalizedText;
